// PACKAGE TYPE
export const packageTypes = [
  { label: "Ampoule", value: "AMPOULE" },
  { label: "Bottle", value: "BOTTLE" },
  { label: "Capsule", value: "CAPSULE" },
  { label: "Cream", value: "CREAM" },
  { label: "Gel", value: "GEL" },
  { label: "Gummy", value: "GUMMY" },
  { label: "Liquid", value: "LIQUID" },
  { label: "Lozenges", value: "LOZENGES" },
  { label: "Lotion", value: "LOTION" },
  { label: "MDI", value: "MDI" },
  { label: "Ointment", value: "OINTMENT" },
  { label: "Pint", value: "PINT" },
  { label: "Powder", value: "POWDER" },
  { label: "Respule", value: "RESPULE" },
  { label: "Rotacap", value: "ROTACAP" },
  { label: "Shampoo", value: "SHAMPOO" },
  { label: "Sachet", value: "SACHET" },
  { label: "Solution", value: "SOLUTION" },
  { label: "Suppository", value: "SUPPOSITORY" },
  { label: "Tablet", value: "TABLET" },
  { label: "Tube", value: "TUBE" },
  { label: "Vial", value: "VIAL" },
];
